import { configureStore } from "@reduxjs/toolkit";
import marketingLeadReducer from "./slices/marketingLeadSlice.js";
import authReducer from "./slices/authSlice";
import employeeReducer from "./slices/employeeSlice";
import roleReducer from "./slices/roleSlice";
import departmentReducer from "./slices/departmentSlice";
import securityQuestionReducer from "./slices/securityQuestionSlice";
import categoryReducer from "./slices/categorySlice";
import subcategoryReducer from "./slices/subcategorySlice";
import inventoryReducer from "./slices/inventorySlice";
import stockReducer from "./slices/stockSlice";
import canteenReducer from "./slices/canteenSlice";
import employeeLogReducer from "./slices/employeeLogSlice";
import inventoryLogReducer from "./slices/inventoryLogSlice";
import profileReducer from "./slices/profileSlice";
import ticketReducer from "./slices/ticketSlice";
import requestIssuanceReducer from "./slices/requestIssuanceSlice";
import securityEmployeeQuestionReducer from "./slices/securityEmployeeQuestionSlice";
import permissionReducer from "./slices/permissionSlice";
import notificationReducer from "./slices/notificationSlice";
import assetAssignReducer from "./slices/assetAssignSlice";
import suggestionReducer from "./slices/suggestionSlice";
import breakTimeLogReducer from "./slices/breakTimeLogSlice";
import requestLogReducer from "./slices/requestLogSlice";
import assetAssignLogReducer from "./slices/assetAssignLogSlice";
import ticketLogReducer from "./slices/ticketLogSlice";
import canteenLogReducer from "./slices/canteenLogSlice";
import walletReducer from "./slices/walletSlice";
import orderReducer from "./slices/orderSlice";
import escalationReducer from "./slices/escalationSlice";
import feedbackReducer from "./slices/feedbackSlice";
import commonReducer from "./slices/commonSlice";
import escalationHistoryReducer from "./slices/escalationHistorySlice";
import settingsReducer from "./slices/settingsSlice";
import teamReducer from "./slices/teamSlice";
import companyReducer from "./slices/companySlice";
import vendorReducer from "./slices/vendorSlice";
import reportReducer from "./slices/reportSlice";
import activityLogReducer from "./slices/activityLogSlice";
import hourlyLogReducer from "./slices/hourlyLogSlice";
import leaveReducer from "./slices/leaveSlice";
import contactReducer from "./slices/contactSlice";
import exhibitionReducer from "./slices/exhibitionSlice";
import leavePolicyReducer from "./slices/leavePolicySlice";
import toDoReducer from "./slices/toDoSlice";
import warrantyReducer from "./slices/warrantySlice";
import todoCategoryReducer from "./slices/todoCategorySlice";
import workTaskReducer from "./slices/workTaskSlice";
import myAttachmentReducer from './slices/myAttachmentSlice';
import interviewApplicationReducer from './slices/interviewApplicationSlice';
import employeeLocationReducer from './slices/employeeLocationSlice';
import generalActivityLogReducer from './slices/generalActivityLogSlice';

export const store = configureStore({
  reducer: {
    marketingLead: marketingLeadReducer,
    auth: authReducer,
    employee: employeeReducer,
    role: roleReducer,
    department: departmentReducer,
    securityQuestion: securityQuestionReducer,
    category: categoryReducer,
    subcategory: subcategoryReducer,
    inventory: inventoryReducer,
    stock: stockReducer,
    canteen: canteenReducer,
    employeeLog: employeeLogReducer,
    inventoryLog: inventoryLogReducer,
    profile: profileReducer,
    ticket: ticketReducer,
    requestIssuance: requestIssuanceReducer,
    securityEmployeeQuestion: securityEmployeeQuestionReducer,
    permission: permissionReducer,
    notification: notificationReducer,
    assetAssign: assetAssignReducer,
    suggestion: suggestionReducer,
    breakTimeLog: breakTimeLogReducer,
    requestLog: requestLogReducer,
    assetAssignLog: assetAssignLogReducer,
    ticketLog: ticketLogReducer,
    canteenLog: canteenLogReducer,
    wallet: walletReducer,
    order: orderReducer,
    escalation: escalationReducer,
    feedback: feedbackReducer,
    common: commonReducer,
    escalationHistory: escalationHistoryReducer,
    settings: settingsReducer,
    team: teamReducer,
    company: companyReducer,
    vendor: vendorReducer,
    report: reportReducer,
    activityLog: activityLogReducer,
    hourlyLog: hourlyLogReducer,
    leave: leaveReducer,
    contact: contactReducer,
    exhibition: exhibitionReducer,
    leavePolicy: leavePolicyReducer,
    toDo: toDoReducer,
    warranty: warrantyReducer,
    todoCategory: todoCategoryReducer,
    workTask: workTaskReducer,
   myAttachment: myAttachmentReducer,
    interviewApplication: interviewApplicationReducer,
    employeeLocation: employeeLocationReducer,
    generalActivityLog: generalActivityLogReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

window.store = store;

export default store;
